import { useState, useEffect } from 'react';

/**
 * Hook that checks if an element is scrollable (has overflow)
 * @param {React.RefObject} ref - Ref to the element to check
 * @param {Array} deps - Dependencies that trigger re-check (default: [])
 * @returns {boolean} - Whether the element is scrollable
 */
export const useIsScrollable = (ref, deps = []) => {
  const [isScrollable, setIsScrollable] = useState(false);

  const checkScrollable = () => {
    requestAnimationFrame(() => {
      const container = ref.current;
      if (container) {
        const hasScroll = container.scrollHeight > container.clientHeight;
        setIsScrollable(hasScroll);
      }
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(checkScrollable, [...deps]);

  return isScrollable;
};
